import { useState, useEffect } from 'react';

import axios from 'axios';

import routes from 'app/routes';

export default function useLearnerStyleQuestions() {
  const [learnerStyleQuestions, setLearnerStyleQuestions] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.learner_style_questions.index)
      .then((response) => {
        setLearnerStyleQuestions(response.data.data);
      });
  }, []);

  return learnerStyleQuestions;
}
